import React, { Component, Fragment } from 'react';
import { Input, InputNumber, Button, Icon, Form, message, Checkbox, Modal } from 'antd';
import _toUpper from 'lodash/toUpper';
import _get from 'lodash/get';

import Coins from '../../components/Coins';
import ColorPicker from '../../components/ColorPicker';
import { getCoinInfo, storeAsset, uploadCoinLogo } from '../../common/fetch';
import { CONTACT_DESCRIPTION_LINK } from '../../config/constants';
import { MISSING_ICON } from '../../config/media';
import { CreateAssetModalWrapper } from './style';

const { Search, TextArea } = Input;
const { Item } = Form;

// const radioStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     height: '30px',
//     lineHeight: '1.2',
//     padding: '24px 0',
//     margin: 0,
//     paddingLeft: '1px',
//     whiteSpace: 'normal',
//     letterSpacing: '-0.15px',
// };

class AssetConfig extends Component {
    constructor() {
        super();
        this.state = {
            isSupply: false,
            showPresetAlert: false
        }
    }

    handleSubmit = (e) => {
        const { isEdit, isConfigureEdit, form, coinFormData, coins, exchangeCoins = [], handleNext } = this.props;
        e.preventDefault();
        form.validateFields((err) => {
            if (!err) {
                if (!isEdit && !isConfigureEdit) {
                    const body = {
                        ...coinFormData,
                    };
                    let coinData = coins.filter((coin) => !coin.active).map((coin) => {
                        return coin.symbol;
                    });
                    let presentKeys = exchangeCoins.map((coin) => coin.symbol);
                    if (presentKeys.includes(body.symbol)) {
                        message.error(`${_toUpper(body.symbol)} is already added in the exchange.`);
                    } else if (coinData.includes(body.symbol)) {
                        this.setState({ showPresetAlert: true });
                    } else {
                        this.updateAsset();
                    }
                } else {
                    handleNext();
                }
            }
        });
    };

    handlePresetAdd = async () => {
        const { coinFormData, handlePresetConfirmation } = this.props;
        const body = {
            ...coinFormData,
        };
        handlePresetConfirmation(body.symbol);
    };

    updateAsset = async () => {
        const { logoFile, iconName, ...resetFormData } = this.props.coinFormData;
        const body = {
            ...resetFormData,
        };
        if (!body.estimated_price) {
            body.estimated_price = 1;
        }
        if (!body.standard) {
            body.standard = "";
        }
        if (!body.network) {
            body.network = "";
        }
        if (!body.logo) {
            body.logo = "";
        }
        if (body.type === 'blockchain'
            && body.network === 'eth'
            && !this.state.isSupply) {
            delete body.meta.supply;
        }
        if (body.decimals) {
            body.decimals = parseInt(body.decimals, 10);
        }
        try {
            if (logoFile) {
                let formData = new FormData();
                formData.append('exchange_name', this.props.exchangeName);
                formData.append('file_name', iconName);
                formData.append('file', logoFile);
                const logo = await uploadCoinLogo(formData);
                body.logo = _get(logo, 'path', '');
                this.props.handleBulkUpdate({ logo: body.logo, logoFile: null, iconName: '' });
            }
            const res = await storeAsset(body);
            if (this.props.getCoins) {
                await this.props.getCoins();
            }
            if (this.props.handleRefreshCoin) {
                await this.props.handleRefreshCoin(body);
            }
            if (res && res.data) {
                this.props.handleNext();
            }
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    }

    handleChangeSupply = (e) => {
        if (e.target.value === 'limited') {
            this.props.handleMetaChange(0, 'supply');
        } else {
            this.props.handleMetaChange(e.target.value, 'supply');
        }
    };

    handleSearch = async (address) => {
        const { handleBulkUpdate, handleMetaChange, coinFormData } = this.props;
        const params = {
            address,
            network: coinFormData.network
        }
        try {
            const res = await getCoinInfo(params);
            if (res.data) {
                const data = {
                    ...res.data,
                    fullname: res.data.name,
                    symbol: res.data.symbol.toLowerCase()
                }
                if (res.data && res.data.supply) {
                    this.setState({ isSupply: true })
                } else {
                    this.setState({ isSupply: false })
                }
                handleBulkUpdate(data);
                handleMetaChange(address, 'contract');
            }
        } catch (error) {
            if (error.data && error.data.message) {
                message.error(error.data.message);
            } else {
                message.error(error.message);
            }
        }
    };

    checkCoin = (rule, value, callback) => {
        let coinData = this.props.coins.filter((coin) => coin.active).map((coin) => {
            return coin.symbol
        })
        if (coinData.includes(value)) {
            callback('This symbol already exists for this asset');
        } else {
            callback();
        }
    };

    checkLower = (rule, value, callback) => {
        if (/[A-Z]/g.test(value)) {
            callback('Asset symbol must be in Lower case');
        } else {
            callback();
        }
    };

    handleCloseAlert = () => {
        this.setState({ showPresetAlert: false });
    };

    renderFields = () => {
        const {
            coinFormData = {},
            handleMetaChange,
            form = {},
        } = this.props;
        const { getFieldDecorator } = form;

        if (coinFormData.type === 'blockchain' && (coinFormData.network === 'eth' || coinFormData.network === 'bnb' || coinFormData.network === 'klay' | coinFormData.network === 'matic')) {
            return (
                <div className="md-field-wrap-search">
                    <div className="sub-title">
                        Contract(
                            <a target='_blank' rel="noopener noreferrer" href={CONTACT_DESCRIPTION_LINK}>
                            <span className="link">what's this?</span>
                        </a>)
                    </div>
                    <Item>
                        {getFieldDecorator("contract", {
                            // initialValue: coinFormData.contract,
                            rules: [
                                {
                                    required: true,
                                    message: 'This field is required!'
                                }
                            ],
                        })(
                            <Search
                                name="contract"
                                enterButton="Search"
                                onChange={(e) => {
                                    handleMetaChange(e.target.value, 'contract')
                                }}
                                onSearch={this.handleSearch}
                                value={coinFormData.meta ? coinFormData.meta.contract : ''}
                            />
                        )}
                    </Item>
                </div>
            )
        } else if (coinFormData.type === 'blockchain' && coinFormData.network !== 'eth') {
            return (
                <div className="md-field-wrap-search">
                    {coinFormData.network === 'other' ?
                        <div>
                            <div className="sub-title">Blockchain name</div>
                            <Item>
                                {getFieldDecorator("blockchainName", {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'This field is required!'
                                        }
                                    ],
                                })(
                                    <Input
                                        onChange={(e) => {
                                            handleMetaChange(e.target.value, 'blockchainName')
                                        }}
                                        name="blockchainName"
                                    />
                                )}
                            </Item>
                        </div>
                        : null
                    }
                    <div className="sub-title">Contract(<a target='_blank' rel='noopener noreferrer' href={CONTACT_DESCRIPTION_LINK}><span className="link">what's this?</span></a>)</div>
                    <Item>
                        {getFieldDecorator("contract", {
                            // initialValue: coinFormData.contract,
                            rules: [
                                {
                                    required: true,
                                    message: 'This field is required!'
                                }
                            ],
                        })(
                            <Input
                                name="contract"
                                enterButton="Search"
                                onChange={(e) => {
                                    handleMetaChange(e.target.value, 'contract')
                                }}
                                onSearch={this.handleSearch}
                                value={coinFormData.meta ? coinFormData.meta.contract : ''}
                            />
                        )}
                    </Item>
                </div>
            )
        }
    }
    render() {
        const {
            coinFormData = {},
            handleChange,
            handleCheckChange,
            handleFileChange,
            handleMetaChange,
            handleBack,
            form = {},
            isConfigureEdit,
            isEdit
        } = this.props;
        const { getFieldDecorator } = form;
        const isBlockchainSearch = coinFormData.type === 'blockchain'
            && (coinFormData.network === 'eth' || coinFormData.network === 'bnb' || coinFormData.network === 'klay' || coinFormData.network === 'matic');

        return (
            <Fragment>
                <div className="title">Create or add a new coin</div>
                <Form onSubmit={this.handleSubmit}>
                    <div className="section-wrapper">
                        {this.renderFields()}
                        <div className="sub-title">Naming and color</div>
                        <div className="color-wrapper">
                            <Coins
                                nohover
                                large
                                small
                                type={(coinFormData.symbol || '').toLowerCase()}
                                fullname={coinFormData.fullname}
                                color={
                                    coinFormData.meta
                                        ? coinFormData.meta.color
                                        : ''
                                }
                                background = {
                                    coinFormData.meta
                                        ? coinFormData.meta.color
                                        : ''
                                }
                                contrast={true}
                            />
                            <div>
                                <div className="md-field-wrap">
                                    {isBlockchainSearch
                                        ? <Fragment>
                                            <div>
                                                <span className="sub-title">Asset name</span>
                                            </div>
                                            <span className="field-description">
                                                {coinFormData.fullname}
                                            </span>
                                        </Fragment>
                                        : (<Fragment>
                                            <div>
                                                <span className="sub-title">Asset name</span>{' '}
                                                <span className="sub-txt">(required)</span>
                                            </div>
                                            <span className="field-description">
                                                Enter the full name for this asset (example 'Bitcoin')
                                            </span>
                                            <Item>
                                                {getFieldDecorator("fullname", {
                                                    initialValue: coinFormData.fullname,
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'This field is required!'
                                                        }
                                                    ],
                                                })(
                                                    <Input
                                                        name="fullname"
                                                        placeholder="Enter long form name"
                                                        onChange={handleChange}
                                                    // value={coinFormData.fullname}
                                                    />
                                                )}
                                            </Item>
                                        </Fragment>)
                                    }
                                </div>
                                <div className="md-field-wrap">
                                    {isBlockchainSearch
                                        ? (
                                            <Fragment>
                                                <div>
                                                    <span className="sub-title">Asset symbol</span>
                                                </div>
                                                <span className="field-description">{coinFormData.symbol}</span>
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                <div>
                                                    <span className="sub-title">Asset symbol</span>
                                                    <span className="sub-txt">(required)</span>
                                                </div>
                                                <span className="field-description">Enter the shorthand symbol for this asset (example 'BTC')</span>
                                                <Item>
                                                    {getFieldDecorator("symbol", {
                                                        initialValue: coinFormData.symbol,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: 'This field is required!'
                                                            },
                                                            {
                                                                max: 5,
                                                                message: 'Symbol must be maximum 5 characters.'
                                                            },
                                                            {
                                                                min: 2,
                                                                message: 'Symbol must be minimum 2 characters.'
                                                            },
                                                            {
                                                                validator: this.checkLower
                                                            },
                                                            {
                                                                validator: (!isConfigureEdit && !isEdit)
                                                                    ? this.checkCoin
                                                                    : null
                                                            }
                                                        ]
                                                    })(
                                                        <Input
                                                            name="symbol"
                                                            placeholder="Enter short hand name"
                                                            onChange={handleChange}
                                                        // value={coinFormData.symbol}
                                                        />
                                                    )}
                                                </Item>
                                            </Fragment>
                                        )
                                    }
                                </div>
                                <div>
                                    <span className="sub-title">Color</span>{' '}<span className='sub-txt'>(for exchange purposes):</span>
                                </div>
                                <ColorPicker
                                    value={
                                        coinFormData.meta
                                            ? coinFormData.meta.color
                                            : ''
                                    }
                                    onChange={(val) => handleMetaChange(val, 'color')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section-wrapper">
                        <div className="sub-title">About</div>
                        <div className="about-wrapper">
                            <div className="md-field-wrap">
                                <div className="sub-title">Description</div>
                                <div className='sub-txt'>Write a short description of this asset</div>
                                <TextArea
                                    placeholder="Input a message"
                                    name="description"
                                    rows={3}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section-wrapper">
                        <div className="sub-title">Icon</div>
                        <div className="d-flex align-items-center">
                            <div className="md-field-wrap">
                                {console.log("coinFormData.logo",coinFormData.logo)}
                                {coinFormData.logo
                                    ? <img src={coinFormData.logo.type ? MISSING_ICON : coinFormData.logo || ''} alt="coin" className="preview-icon" />
                                    : <div className="icon-upload">
                                        <div className="file-container">
                                            <label>
                                                <Icon type="upload" style={{ fontSize: '94px', color: '#808080', marginRight: '8px' }} />
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileChange(e, 'logo')}
                                                    name="logo"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="md-field-wrap">
                                <div>
                                    <span className="sub-title">Upload asset icon</span>{' '}
                                    <span className='sub-txt'>(this icon will be used in various places on your exchange):</span>
                                </div>
                                <div className="file-container">
                                    <label className="link">
                                        <span className='sub-txt'>+ Upload ICON 75x75px</span>
                                        <input
                                            type="file"
                                            onChange={(e) => handleFileChange(e, 'logo')}
                                            name="logo"
                                            accept="image/jpg, image/jpeg, image/png"
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-wrapper">
                        <div className="sub-title">Decimal points</div>
                        <div className="d-flex align-items-center">
                            <div className="preview-icon"></div>
                            <div className="md-field-wrap">
                                {isBlockchainSearch
                                    ? <Fragment>
                                        <div>
                                            <span className="sub-title">Decimal points</span>
                                            <div className='sub-txt'>{coinFormData.meta.decimal_points}</div>
                                        </div>
                                    </Fragment>
                                    : <Fragment>
                                        <div>
                                            <span className="sub-title">Decimal points</span>{' '}<span className='sub-txt'>(max 18):</span>
                                        </div>
                                        <InputNumber
                                            name="decimal_points"
                                            min={0}
                                            max={18}
                                            onChange={(val) => handleMetaChange(val, 'decimal_points')}
                                            value={coinFormData.meta.decimal_points}
                                        />
                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                    {/* {((isBlockchainSearch && this.state.isSupply) || !isBlockchainSearch)
                        ?
                        <div className="section-wrapper last">
                            <div className="sub-title">Supply</div>
                            <div className="d-flex align-items-center">
                                <div className="preview-icon"></div>
                                <div className="md-field-wrap">
                                    {isBlockchainSearch
                                        ? <Fragment>
                                            <div>
                                                <span className="sub-title">Supply</span>
                                                <div>{coinFormData.meta.supply}</div>
                                            </div>
                                        </Fragment>
                                        :
                                        <Radio.Group
                                            name="supply"
                                            onChange={this.handleChangeSupply}
                                            value={coinFormData.meta.supply === 'other'
                                                ? 'other'
                                                : 'limited'
                                            }
                                        >
                                            <Radio style={radioStyle} value={'limited'}>
                                                Limited supply
                                            </Radio>
                                            {coinFormData.meta.supply !== 'other'
                                                ? <div>
                                                    <div>
                                                        <span className="sub-title">Supply</span>
                                                    </div>
                                                    {isBlockchainSearch
                                                        ? <div>{coinFormData.meta.supply}</div>
                                                        : <InputNumber
                                                            name="supply"
                                                            min={0}
                                                            onChange={(val) => handleMetaChange(val, 'supply')}
                                                            value={coinFormData.meta.supply}
                                                        />
                                                    }
                                                </div>
                                                : null
                                            }
                                            <Radio style={radioStyle} value={'other'}>
                                                Other
                                                </Radio>
                                        </Radio.Group>
                                    }
                                </div>
                            </div>
                        </div>
                        : null
                    } */}
                    <div className="section-wrapper last">
                        <div className="sub-title">Make public</div>
                        <div className="md-field-wrap">
                            <div className='sub-txt'>Make this asset public so that others can see and add this asset to their platform.</div>
                            <Checkbox
                                name="is_public"
                                onChange={handleCheckChange}
                                className="sub-title"
                                checked={coinFormData.is_public}
                            >
                                Make Public
                            </Checkbox>
                        </div>
                    </div>
                    <div className="btn-wrapper">
                        <Button type="primary" onClick={handleBack}>
                            Back
                        </Button>
                        <div className="separator"></div>
                        <Button type="primary" htmlType="submit">
                            Next
                        </Button>
                    </div>
                </Form>
                <Modal
                    visible={this.state.showPresetAlert}
                    footer={null}
                    onCancel={this.handleCloseAlert}
                >
                    <CreateAssetModalWrapper>
                        <div className='title'>
                            {`${_toUpper(coinFormData.symbol)} is already created by some one. Do you really want to add it on exchange?`}
                            <div className="btn-wrapper">
                                <Button type="primary" className="green-btn" onClick={this.handleCloseAlert}>
                                    Cancel
                                </Button>
                                <div className="separator"></div>
                                <Button type="primary" className="green-btn" onClick={this.handlePresetAdd}>
                                    Okay
                                </Button>
                            </div>
                        </div>
                    </CreateAssetModalWrapper>
                </Modal>
            </Fragment>
        );
    }
}

export default Form.create({ name: 'AssetConfigName' })(AssetConfig);
